import { useCallback, useEffect, useState } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useTag(id) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTag = useCallback(async () => {
    if (!id) return;

    setLoading(true);
    const { response, data } = await API.fetchTag(token, id);

    if (response.ok) {
      setResult(data);
      setError(null);
    } else {
      setResult(null);
      setError({ status: response.status, ...data });
    }

    setLoading(false);
  }, [id, token]);

  useEffect(() => {
    fetchTag();
  }, [fetchTag]);

  return {
    loading,
    error,
    tag: result,
    refresh: fetchTag,
  };
}
